export const listToMap = <T extends Array<any>>(
  list: T,
  uniqueKey: keyof T[number],
  valueKey: keyof T[number],
): {
  [key: string]: T[number]
} => {
  return (list || []).reduce((acc, current) => {
    return {
      ...acc,
      [current[uniqueKey]]: current[valueKey],
    }
  }, {})
}
